import React, { useEffect, useState, useCallback, useMemo } from 'react';
import cn from 'classnames';
import { t } from 'i18next';

import TipPercentageButton from '../TipPercentageButton';
import TipCustomAmountButton from '../TipCustomAmountButton';

import { CURRENT_COUNTRY_ID } from '~constants/environment';

import styles from './styles.module.scss';
import { KEY_INPUT_TIP, KEY_WITHOUT_TIP, TIPS_BY_COUNTRIES } from './constants';

const useTips = ({ onSetIndex, subtotal, onResetTip, noCustomTip }) => {
  const [selectedTip, setSelectedTip] = useState();
  const [canSelectDefaultOption, setCanSelectDefaultOption] = useState(false);

  const onSelect = useCallback(
    index => {
      setSelectedTip(index);
      onSetIndex(index);
    },
    [onSetIndex]
  );

  useEffect(() => {
    if (!canSelectDefaultOption) {
      setCanSelectDefaultOption(true);
      onSelect(
        subtotal > TIPS_BY_COUNTRIES[CURRENT_COUNTRY_ID].limitAmount
          ? 'without-tip'
          : TIPS_BY_COUNTRIES[CURRENT_COUNTRY_ID].tipByDefault
      );
    }
  }, [subtotal, canSelectDefaultOption, onSelect]);

  const clearSelect = () => {
    setSelectedTip(false);
    onSetIndex('without-tip');
  };

  const renderPercentageButton = useMemo(
    () =>
      TIPS_BY_COUNTRIES[CURRENT_COUNTRY_ID].tipOptions.map(tip => {
        let tipProps = {};

        if (tip.canRenderCondition) {
          tipProps = {
            percentage: tip.percentage || null,
            totalTip: tip.percentage ? 0 : tip.amount
          };

          if (!tip.renderWithTotalValidation(subtotal)) {
            if (selectedTip === tip.index) {
              onResetTip();
            }
            return false;
          }
        }

        return (
          <TipPercentageButton
            key={tip.id}
            index={tip.index}
            percentage={tip.percentage}
            handleSelect={onSelect}
            isSelected={selectedTip === tip.index}
            {...tipProps}
          />
        );
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedTip, subtotal]
  );
  const tipCustomAmountButton1 = (
    <TipCustomAmountButton
      index={KEY_INPUT_TIP}
      customText={t('TipSelection:anotherAmount')}
      customInput
      handleSelect={onSelect}
      handleClearSelect={clearSelect}
      containerClassName={cn({
        [styles.selected]: selectedTip === KEY_INPUT_TIP
      })}
    />
  );
  const tipCustomAmountButton2 = (
    <TipCustomAmountButton
      index={KEY_WITHOUT_TIP}
      customText={t('TipSelection:noTip')}
      handleSelect={onSelect}
      containerClassName={cn({
        [styles.selected]: selectedTip === KEY_WITHOUT_TIP
      })}
    />
  );
  const defaultOrderComponents = [
    renderPercentageButton,
    ...(noCustomTip ? [] : [tipCustomAmountButton1]),
    tipCustomAmountButton2
  ];
  const componentOrderMap = {
    cl: [tipCustomAmountButton2, renderPercentageButton, ...(noCustomTip ? [] : [tipCustomAmountButton1])],
    cr: defaultOrderComponents,
    pa: defaultOrderComponents,
    gt: defaultOrderComponents,
    es: [tipCustomAmountButton2, ...(noCustomTip ? [] : [tipCustomAmountButton1]), renderPercentageButton],
    pt: [tipCustomAmountButton2, ...(noCustomTip ? [] : [tipCustomAmountButton1]), renderPercentageButton]
  };
  const componentOrder = componentOrderMap[CURRENT_COUNTRY_ID] || [];
  return {
    componentOrder
  };
};

export default useTips;
